import React from 'react'
import AdviserProfileAreasOfSpecialisation from '../../../common/AdviserProfiles/AdviserProfileAreasOfSpecialisation'
import * as styles from './_AdviserProfileAreasOfSpecialisationEditor.scss'
import { connect } from 'react-redux'
import { FormCheck } from 'react-bootstrap'
import { actions } from './adviserProfileAreasOfSpecialisationEditorActions'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class adviserProfileAreasOfSpecialisationEditorActions extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditingAreasOfSpecialisation: PropTypes.func.isRequired,
    cancelEditingAreasOfSpecialisation: PropTypes.func.isRequired,
    fetchAreasOfSpecialisation: PropTypes.func.isRequired,
    allAreasOfSpecialisation: PropTypes.array.isRequired,
    areaOfSpecialisationSelectedChanged: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    validationstate: PropTypes.object.isRequired,
    editingProfile: PropTypes.bool.isRequired
  }

  componentDidMount () {
    this.props.fetchAreasOfSpecialisation()
  }

  render () {
    const profile = this.props.profile
    const selectedAreasOfSpecialisation = this.props.profile.financialServicesOffered || []
    if (this.props.editingProfile) {
      const allAreasOfSpecialisation = (this.props.allAreasOfSpecialisation || []).map(area => ({ ...area }))
      allAreasOfSpecialisation.forEach((areaOfSpecialisation) => {
        var selected = false
        selectedAreasOfSpecialisation.forEach((selectedAreaOfSpecialisation) => {
          selected = selected || selectedAreaOfSpecialisation.financialServiceId === areaOfSpecialisation.financialServiceId
        })
        areaOfSpecialisation.selected = selected
      })
      return <div>
        <h4 className={styles['title']}>Services Offered</h4>
        <form className={styles['form-bottom-margin']}>
          {allAreasOfSpecialisation.map((areaOfSpecialisation) => {
            return <FormCheck
              key={areaOfSpecialisation.financialServiceId}
              type="checkbox"
              checked={areaOfSpecialisation.selected}
              value={areaOfSpecialisation.financialServiceId}
              onChange={() => {
                this.props.areaOfSpecialisationSelectedChanged(areaOfSpecialisation)
              }}
              label={areaOfSpecialisation.name}
            />

          })}
        </form>
      </div>
    }
    return <AdviserProfileAreasOfSpecialisation areas={profile.financialServicesOffered || []} />
  }
}

const mapStateToProps = ({adviserProfileEditorContainer}) => {
  return {
    loading: adviserProfileEditorContainer.areasOfSpecialisation.loadingAreasOfSpecialisation,
    formIsValid: adviserProfileEditorContainer.areasOfSpecialisation.isInvalid.formIsValid,
    validationstate: adviserProfileEditorContainer.areasOfSpecialisation.isInvalid,
    submitting: adviserProfileEditorContainer.areasOfSpecialisation.submitting,
    allAreasOfSpecialisation: adviserProfileEditorContainer.areasOfSpecialisation.allAreasOfSpecialisation,
    editingProfile: adviserProfileEditorContainer.editingProfile
  }
}

const mapDispatchToProps = (dispatch) => {
  const { edit, fetch, set } = actions
  return bindActionCreators({
    startEditingAreasOfSpecialisation: edit.start,
    cancelEditingAreasOfSpecialisation: edit.cancel,
    fetchAreasOfSpecialisation: fetch.fetchAreasOfSpecialisation,
    areaOfSpecialisationSelectedChanged: set.selectionChanged
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (adviserProfileAreasOfSpecialisationEditorActions))
